import axios from 'axios';

// Haversine formula to calculate distance between two points in km
export const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Radius of the earth in km
    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lon2 - lon1);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in km
    return d;
};

const deg2rad = (deg) => {
    return deg * (Math.PI / 180);
};

// Geocode an address string to {lat, lon} using Google Maps Geocoding API
export const geocodeAddress = async (address) => {
    try {
        const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
        if (!apiKey) {
            console.error("Google Maps API key is missing. Please add REACT_APP_GOOGLE_MAPS_API_KEY to your .env file.");
            return null;
        }

        const response = await axios.get('https://maps.googleapis.com/maps/api/geocode/json', {
            params: {
                address: address,
                key: apiKey
            }
        });

        if (response.data && response.data.status === 'OK' && response.data.results.length > 0) {
            const location = response.data.results[0].geometry.location;
            return {
                lat: location.lat,
                lon: location.lng, // Google returns 'lng', we map it to our app's 'lon' convention
                display_name: response.data.results[0].formatted_address
            };
        }
        return null;
    } catch (error) {
        console.error("Google Geocoding error:", error);
        return null;
    }
};

export const calculateTravelFee = (distanceKm, pricePerKm, freeRadiusKm) => {
    if (distanceKm <= freeRadiusKm) return 0;
    return (distanceKm - freeRadiusKm) * pricePerKm;
};
